import React from 'react';
import { Outlet } from 'react-router-dom';
import { ContentContainer, BreadcrumbNav } from '#components';
import { t } from '#i18n';

import { FiltersProvider } from './contexts/filters';

const pathTree = [
  {
    name: t('stats.pullRequestReviews.title'),
    segment: 'pull-request-reviews',
    children: [
      { name: t('stats.pullRequestReviews.overview.title'), segment: 'overview' },
      { name: t('stats.pullRequestReviews.overTime.title'), segment: 'over-time' },
    ],
  },
];

export const PullRequestReviews = () => (
  <ContentContainer topContent={<BreadcrumbNav rootPath="/stats" pathTree={pathTree} />}>
    <FiltersProvider>
      <Outlet />
    </FiltersProvider>
  </ContentContainer>
);
